import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddCustomerModule } from '../../customer/add/add-customer.module';
import { ValidationResultsModule } from '../../shared/components/validation-results/validation-results.module';
import { CustomerImageService } from '../shared/customer-image.service';
import { IndividualSearchModule } from './individual/individual-search.module';
import { OrganizationSearchModule } from './organization/organization-search.module';
import { CustomerSearchContainerComponent } from './search-container/search-container.component';
import { CustomerSearchResultsModule } from './search-results/search-results.module';

@NgModule({
    declarations: [
        CustomerSearchContainerComponent
    ],
    providers: [
        CustomerImageService
    ],
    imports: [
        AddCustomerModule,
        CommonModule,
        CustomerSearchResultsModule,
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        IndividualSearchModule,
        OrganizationSearchModule,
        ReactiveFormsModule,
        ValidationResultsModule
    ],
    exports: [
        AddCustomerModule,
        CustomerSearchContainerComponent
    ]
})
export class CustomerSearchSharedModule { }
